package navigation.root.home

import org.koin.core.module.dsl.factoryOf
import org.koin.dsl.module

val homeModule
    get() =
        module {
            factoryOf(::HomeScreenModel)
        }
